// client/src/components/auth/CompleteProfile.js
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import ApiPlayers from '../../api/ApiPlayers'
import PageLayout from '../common/layout/PageLayout'
import toastr from 'toastr'

function CompleteProfile() {
  const { user, loading } = useAuth()
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !user) {
      navigate('/sign-in')
    }
  }, [loading, user, navigate])

  const handleContinue = async () => {
    if (!user) return
    setSubmitting(true)
    try {
      // Ensure a primary player exists (server should have created it; this is a safety net)
      const players = await ApiPlayers.getMyPlayers()
      const primary = players.find((p) => p.primary_player)
      if (!primary) {
        await ApiPlayers.create({
          user_id: user.id,
          first_name: user.firstname || '',
          last_name: user.lastname || '',
          primary_player: true,
        })
      }
      navigate('/profile')
    } catch (e) {
      console.error(e)
      toastr.error('Could not set up your player profile. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  if (loading || !user) {
    return (
      <PageLayout title="Setting up profile...">
        <div style={{ padding: 24 }}>Loading...</div>
      </PageLayout>
    )
  }

  return (
    <PageLayout title="Welcome! Let's complete your profile">
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <p>
          Your account was created with {user.email}. We created a starter
          player profile for you. You can review and fill in details like your
          name, phone, and rating next.
        </p>
        <div style={{ marginTop: 16 }}>
          <button
            className="btn btn-primary"
            onClick={handleContinue}
            disabled={submitting}
          >
            {submitting ? 'Continuing...' : 'Go to My Profile'}
          </button>
        </div>
      </div>
    </PageLayout>
  )
}

export default CompleteProfile
